import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { allMovies } from "@/lib/movies";

const tabs = [
  { key: "latest", label: "最新上线" },
  { key: "rating", label: "高分佳作" },
  { key: "views", label: "最多观看" },
] as const;

type TabKey = (typeof tabs)[number]["key"];

export default function PicksSection() {
  const [active, setActive] = useState<TabKey>("latest");

  const list = useMemo(() => {
    const sorted = [...allMovies].sort((a, b) => {
      if (active === "rating") return b.rating - a.rating;
      if (active === "views") return b.views - a.views;
      return a.releaseDate < b.releaseDate ? 1 : -1;
    });
    return sorted.slice(0, 8);
  }, [active]);

  return (
    <section className="px-4 md:px-8 lg:px-12 pb-14 md:pb-20">
      <div className="max-w-shell mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5 mb-6 md:mb-8">
          <SectionHeading
            eyebrow="EDITOR'S PICKS"
            title="精选电影推荐"
            description="由编辑团队从片库中挑选的口碑之作，涵盖家庭、情感与社会议题。"
          />
          <div className="flex items-center gap-1 p-1 rounded-full border border-background-200/80 bg-background-100/60 self-start lg:self-auto shrink-0">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`h-8 px-4 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/category/all"
            className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-2 hover:border-primary-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整片库
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}